import { Route } from '@angular/router';
import { ADMIN_ROUTES } from '../../../common/constants/admin.routing.constants';

export const singleVariableRoutes: Route[] = [
  {
    path: `:variableModule/${ADMIN_ROUTES.SINGLE_VARIABLES}/:variableId`,
    loadComponent: () =>
      import('./single-variable-details/single-variable-details.component').then(
        m => m.SingleVariableDetailsComponent
      ),
    children: [
      {
        path: '',
        async loadComponent() {
          const c =
            await import('./single-variable-details/single-variable-options-list/single-variable-options-list.component');
          return c.SingleVariableOptionsListComponent;
        },
      },
      {
        path: 'add',
        async loadComponent() {
          const c =
            await import('./single-variable-details/single-variable-options-form/single-variable-options-form.component');
          return c.SingleVariableOptionsFormComponent;
        },
      },
      {
        path: 'edit/:optionId',
        async loadComponent() {
          const c =
            await import('./single-variable-details/single-variable-options-form/single-variable-options-form.component');
          return c.SingleVariableOptionsFormComponent;
        },
      },
    ],
  },
];
